<template>
  <NuxtLayout name="app">
    <UContainer id="container" class="flex flex-col grow pb-30 pt-16 md:pt-10">
      <slot />
    </UContainer>
  </NuxtLayout>
</template>
